// Blast Email tab (MingZe only): create a campaign, tick members, send from no_reply@mzprotrading.com.
import React from "react";
import { Alert, Button, Col, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, Spinner } from "reactstrap";
import { CampaignHistory, CampaignProgress, MemberPicker, MessageComposer, PageShell } from "./memberComponents.jsx";
import { isOwner, memberPost } from "./memberApi.js";

const EMPTY = { name: '', subject: '', content: '', imageurl: '', selected: {} };

class BlastEmail extends React.Component {
  state = Object.assign({ tab: 'new', members: [], loading: true, error: '', sending: false, progressId: null, testto: '', testing: false, testresult: null }, EMPTY);

  componentDidMount() {
    if (!isOwner()) return;
    memberPost('member-list').then(json => this.setState({ loading: false, members: json.success == 1 ? json.members : [] }));
  }

  canSelect = (m) => m.status === 'Active' && m.emailconsent == 1 && !!m.email;
  reasonOf = (m) => m.status !== 'Active' ? 'Inactive' : !m.email ? 'No email' : 'Unsubscribed';

  send = () => {
    const s = this.state;
    const ids = Object.keys(s.selected);
    if (!s.name.trim() || !s.subject.trim() || !s.content.trim()) { this.setState({ error: 'Please fill in campaign name, subject and content' }); return; }
    if (ids.length === 0) { this.setState({ error: 'Please tick at least one member' }); return; }
    if (!window.confirm('Send this email to ' + ids.length + ' member(s) now?')) return;
    this.setState({ sending: true, error: '' });
    memberPost('campaign-send', {
      channel: 'email', name: s.name.trim(), subject: s.subject.trim(), content: s.content, imageurl: s.imageurl, intervalsec: 3, memberids: JSON.stringify(ids),
    }).then(json => {
      if (json.success == 1) this.setState(Object.assign({ sending: false, progressId: json.campaignid }, EMPTY));
      else this.setState({ sending: false, error: json.message });
    });
  };

  test = () => {
    const s = this.state;
    if (!s.testto.trim()) return;
    this.setState({ testing: true, testresult: null });
    memberPost('test-send', { channel: 'email', to: s.testto.trim(), subject: s.subject, content: s.content, imageurl: s.imageurl })
      .then(json => this.setState({ testing: false, testresult: json }));
  };

  reuse = (c) => this.setState({ tab: 'new', name: c.name + ' (copy)', subject: c.subject, content: c.content, imageurl: c.imageurl, selected: {} });

  render() {
    const s = this.state;
    return (
      <PageShell title="Blast Email" ownerOnly>
        <Nav tabs className="mb-4">
          <NavItem><NavLink href="#" active={s.tab === 'new'} onClick={e => { e.preventDefault(); this.setState({ tab: 'new' }); }}>New Campaign</NavLink></NavItem>
          <NavItem><NavLink href="#" active={s.tab === 'history'} onClick={e => { e.preventDefault(); this.setState({ tab: 'history' }); }}>Campaign History</NavLink></NavItem>
        </Nav>

        {s.tab === 'history' ? (
          <CampaignHistory key={s.progressId || 'h'} channel="email" onReuse={this.reuse} onResume={id => this.setState({ progressId: id })} />
        ) : (
          <>
            <Row>
              <Col lg="7">
                <h4>1. Email content</h4>
                <FormGroup><Label className="form-control-label">Campaign name (internal)</Label>
                  <Input value={s.name} onChange={e => this.setState({ name: e.target.value })} placeholder="e.g. Raya Promo 2026" maxLength={150} /></FormGroup>
                <FormGroup><Label className="form-control-label">Email subject</Label>
                  <Input value={s.subject} onChange={e => this.setState({ subject: e.target.value })} placeholder="e.g. 🎉 Raya Special for {name}!" maxLength={200} /></FormGroup>
                <FormGroup><Label className="form-control-label">Email content</Label>
                  <MessageComposer value={s.content} onChange={content => this.setState({ content })} imageurl={s.imageurl} onImageChange={imageurl => this.setState({ imageurl })}
                    placeholder={"Hi {name},\n\nWrite your promotion here..."} rows={10} /></FormGroup>
                <small className="text-muted d-block mb-3">Sent from no_reply@mzprotrading.com. An unsubscribe link is added automatically.</small>
                <Row className="align-items-end">
                  <Col md="8"><FormGroup className="mb-2"><Label className="form-control-label">Send a test to</Label>
                    <Input type="email" placeholder="your@email.com" value={s.testto} onChange={e => this.setState({ testto: e.target.value })} /></FormGroup></Col>
                  <Col md="4" className="mb-2"><Button color="secondary" onClick={this.test} disabled={s.testing}>{s.testing ? <Spinner size="sm" /> : 'Send test'}</Button></Col>
                </Row>
                {s.testresult ? <Alert color={s.testresult.success == 1 ? 'success' : 'danger'} className="py-2">{s.testresult.success == 1 ? 'Test email sent' : s.testresult.message}</Alert> : null}
              </Col>
              <Col lg="5">
                <h4>Preview</h4>
                <div style={{ background: '#f4f5f7', padding: 16, borderRadius: 8 }}>
                  <div style={{ background: '#fff', borderRadius: 8, padding: 16, fontSize: 14 }}>
                    <div className="text-muted mb-2" style={{ fontSize: 12 }}>Subject: <strong>{(s.subject || '').replace(/\{name\}/g, 'Ali')}</strong></div>
                    {s.imageurl ? <img src={s.imageurl} alt="" style={{ maxWidth: '100%', borderRadius: 6, marginBottom: 8 }} /> : null}
                    <div style={{ whiteSpace: 'pre-wrap' }}>{(s.content || '').replace(/\{name\}/g, 'Ali').replace(/\{memberid\}/g, 'MZ000001')}</div>
                  </div>
                </div>
              </Col>
            </Row>

            <h4 className="mt-4">2. Tick members to send</h4>
            {s.loading ? <Spinner /> : (
              <MemberPicker members={s.members} selected={s.selected} onChange={selected => this.setState({ selected })}
                canSelect={this.canSelect} reasonOf={this.reasonOf} contactLabel="Email" contactOf={m => m.email} />
            )}

            {s.error ? <Alert color="danger" className="mt-3">{s.error}</Alert> : null}
            <div className="text-right mt-3">
              <Button color="primary" size="lg" onClick={this.send} disabled={s.sending}>
                {s.sending ? <Spinner size="sm" /> : 'Confirm & Send to ' + Object.keys(s.selected).length + ' member(s)'}
              </Button>
            </div>
          </>
        )}

        {s.progressId ? <CampaignProgress campaignid={s.progressId} onClose={() => this.setState({ progressId: null, tab: 'history' })} /> : null}
      </PageShell>
    );
  }
}

export default BlastEmail;
